import { Booking } from "../../domain/models/booking.model";
import { IApiBooking, IApiBookingDetailed } from "../interfaces/booking-api.interface";
import { BookingSpaceMapper } from "./space.mapper";

export class BookingMapper {

  static toJSON(booking: Booking): IApiBooking {
    return {
      id: booking?.id,
      status: booking.status,
      accountId: booking.accountId,
      customer: booking.customer,
      isActive: booking.isActive,
      name: booking.name,
      spaces: booking.spaces.map(space => BookingSpaceMapper.toJSON(space)),
      lockedBy: '',
      zone: booking.zone,
      date: new Date(booking.date).toUTCString(),
      startTime: booking.startTime,
      endTime: booking.endTime,
      partySize: booking.partySize,
      financial: booking.financial,
      notes: booking.notes,
      bookerNotes: booking.bookerNotes,
      referredBy: booking.referredBy,
      createdAt: booking.createdAt,
      createdBy: booking.createdBy,
      updatedAt: booking.updatedAt,
      updatedBy: booking.updatedBy,
      isClosed: booking.isClosed
    };
  }

  static toDetailedJSON(booking: Booking): IApiBookingDetailed {
    return {
      customerId: booking.customer.id ?? '',
      name: booking.name ?? '',
      email: booking.customer.email ?? '',
      phone: booking.customer.phone ?? '',
      spaceIds: booking.spaces.length > 0 ? booking.spaces.map(space => space.id ?? '') : [],
      zoneId: booking.zone.id ?? '',
      serviceId: '',
      date: new Date(booking.date).toUTCString(),
      startTime: parseInt(booking.startTime) || 0,
      endTime: parseInt(booking.endTime) || 0,
      partySize: booking.partySize || 0,
      status: booking.status || '',
      price: booking.financial.bookingPrice || 0,
      rateId: '',
      notes: booking.notes ?? '',
      accountId: booking.accountId ?? '',
      bookerNotes: booking.bookerNotes ?? '',
      referredBy: booking.referredBy?.id || '',
      code: '',
      totalProducts: booking.financial.currentConsumption || 0,
      totalServiceCharge: 0,
      totalTips: 0,
      walkin: false,
      durationLimit: 0,
      eventId: '',
      depositAmount: booking.financial.deposit || 0,
      isDepositPaid: booking.financial.paid >= booking.financial.deposit,
      depositPaidAmount: Math.min(booking.financial.paid, booking.financial.deposit),
      minimumSpend: booking.minConsumption || 0,
      coverChargeAmount: booking.financial.coverCharge?.total || 0,
      payments: [],
      refunds: [],
      products: [],
      updatedBy: booking.updatedBy ?? '',
      updatedAt: booking.updatedAt ?? 0,
      customer: booking.customer ?? {},
      financial: booking.financial ?? {},
      spaces: booking.spaces.length > 0 ? booking.spaces.map(space => BookingSpaceMapper.toJSON(space)) : [],
      zone: booking.zone ?? {},
      referredByData: booking.referredBy ?? {},
      entries: [],
      isClosed: booking.isClosed
    };
  }

  static fromJSON(data: IApiBooking): Booking {
    const spaces = (data.spaces ?? []).map(spaceData =>
      BookingSpaceMapper.fromJSON(spaceData)
    );

    return new Booking(
      data?.id,
      data.status,
      data.isActive,
      data.accountId,
      data.customer,
      data.name,
      spaces,
      data.zone,
      data.date,
      data.startTime,
      data.endTime,
      data.partySize,
      data.financial,
      data.lockedBy,
      data.notes,
      data.bookerNotes,
      data.referredBy,
      data.createdAt,
      data.createdBy,
      data.updatedAt,
      data.updatedBy,
      data.isClosed
    );
  }
}
